"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4722],{

/***/ 6995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-left_svg__h-5 arrow-left_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M9.707 16.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L5.414 9H17a1 1 0 1 1 0 2H5.414l4.293 4.293a1 1 0 0 1 0 1.414z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowLeft);

/***/ }),

/***/ 7104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-right_svg__h-5 arrow-right_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 3.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414L14.586 11H3a1 1 0 1 1 0-2h11.586l-4.293-4.293a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRight);

/***/ }),

/***/ 4145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPencilAlt = function SvgPencilAlt(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "pencil-alt_svg__h-6 pencil-alt_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.232 5.232 3.536 3.536m-2.036-5.036a2.5 2.5 0 1 1 3.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgPencilAlt);

/***/ }),

/***/ 8405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "trash_svg__h-6 trash_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTrash);

/***/ }),

/***/ 5823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



const Badge = (param)=>{
    let { children , color ="gray" , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("inline-flex h-5 cursor-default items-center rounded-md px-1 text-xs lg:text-sm", {
            "bg-slate-200 text-slate-500": color === "gray",
            "bg-amber-100 text-amber-500": color === "amber",
            "bg-green-100/50 text-green-500": color === "green",
            "bg-rose-100/50 text-rose-500": color === "red",
            "bg-cyan-100/50 text-cyan-500": color === "blue"
        }, className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Badge);


/***/ }),

/***/ 6683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const CompactButton = (param)=>{
    let { icon: Icon , children , onClick  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "inline-flex h-5 w-5 items-center justify-center rounded-full bg-slate-100 text-slate-400 transition-colors hover:bg-slate-200 active:bg-slate-300 active:text-slate-500",
        onClick: onClick,
        children: Icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            className: "h-3 w-3"
        }) : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CompactButton);


/***/ }),

/***/ 5664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



const DateCard = (param)=>{
    let { annotation , className , day , dow , month  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("relative inline-flex h-14 w-14 items-center justify-center rounded-md border border-slate-200 bg-white p-1 text-center", className),
        children: [
            annotation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute -top-3 -right-3 z-20",
                children: annotation
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    dow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "-mt-3 bg-white text-center text-xs text-slate-400",
                        children: dow
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center text-xl font-bold leading-none",
                        children: day
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center text-xs font-semibold uppercase leading-normal text-slate-500",
                        children: month
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DateCard);


/***/ }),

/***/ 3702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ error_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/button.tsx
var components_button = __webpack_require__(5295);
// EXTERNAL MODULE: ./src/components/icons/chat.svg
var chat = __webpack_require__(5850);
;// CONCATENATED MODULE: ./src/components/icons/emoji-sad.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgEmojiSad = function SvgEmojiSad(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "emoji-sad_svg__h-6 emoji-sad_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.172 16.172a4 4 0 0 1 5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
  })));
};

/* harmony default export */ var emoji_sad = (SvgEmojiSad);
// EXTERNAL MODULE: ./src/components/crisp-chat.tsx
var crisp_chat = __webpack_require__(8040);
;// CONCATENATED MODULE: ./src/components/error-page.tsx









const ErrorPage = (param)=>{
    let { icon: Icon = emoji_sad , title , description  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("errors");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto flex h-full max-w-full items-center justify-center px-4 py-8 lg:w-[1024px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            className: "mb-4 inline-block w-24 text-slate-400"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-3xl font-bold text-primary-500 ",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-center space-x-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    passHref: true,
                                    className: "btn-default",
                                    children: t("goToHome")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chat/* default */.Z, {}),
                                    onClick: crisp_chat/* showCrispChat */.Sr,
                                    children: t("startChat")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var error_page = (ErrorPage);


/***/ }),

/***/ 13:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _icons_spinner_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8374);




const FullPageLoader = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(" flex h-full items-center justify-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-primary-500 flex items-center rounded-lg px-4 py-3 text-sm text-white shadow-sm",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_spinner_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "mr-3 h-5 animate-spin"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullPageLoader);


/***/ }),

/***/ 236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(692);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _poll_user_avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4371);





const NameInput = (param, ref)=>{
    let { value , defaultValue , className , ...forwardProps } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("app");
    var _ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex items-center",
        children: [
            value ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_poll_user_avatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                name: (_ref = value !== null && value !== void 0 ? value : defaultValue) !== null && _ref !== void 0 ? _ref : "",
                className: "absolute left-2"
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: ref,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("input", {
                    "pl-9": value || defaultValue
                }, className),
                placeholder: t("yourName"),
                value: value,
                ...forwardProps
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(NameInput));


/***/ }),

/***/ 4278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useParticipants; },
/* harmony export */   "n": function() { return /* binding */ ParticipantsProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(692);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3757);
/* harmony import */ var _full_page_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13);
/* harmony import */ var _use_required_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8355);






const ParticipantsContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createContext(null);
const useParticipants = ()=>{
    return (0,_use_required_context__WEBPACK_IMPORTED_MODULE_5__/* .useRequiredContext */ .a)(ParticipantsContext);
};
const ParticipantsProvider = (param)=>{
    let { children , pollId  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("app");
    const { data: participants  } = _utils_trpc__WEBPACK_IMPORTED_MODULE_3__/* .trpc.useQuery */ .S.useQuery([
        "polls.participants.list",
        {
            pollId
        }
    ]);
    const getParticipants = (optionId, voteType)=>{
        if (!participants) {
            return [];
        }
        return participants.filter((participant)=>{
            return participant.votes.some((vote)=>{
                return vote.optionId === optionId && vote.type === voteType;
            });
        });
    };
    // TODO (Luke Vella) [2022-05-18]: Add mutations here
    if (!participants) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_full_page_loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: t("loadingParticipants")
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParticipantsContext.Provider, {
        value: {
            participants,
            getParticipants
        },
        children: children
    });
};


/***/ }),

/***/ 3035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ PollContextProvider; },
/* harmony export */   "XW": function() { return /* binding */ usePoll; }
/* harmony export */ });
/* unused harmony export PollContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(692);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _components_icons_trash_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8405);
/* harmony import */ var _utils_date_time_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5422);
/* harmony import */ var _utils_dayjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4752);
/* harmony import */ var _error_page__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3702);
/* harmony import */ var _participants_provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4278);
/* harmony import */ var _use_required_context__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8355);
/* harmony import */ var _user_provider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7348);











const PollContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createContext(null);
PollContext.displayName = "PollContext.Provider";
const usePoll = ()=>{
    const context = (0,_use_required_context__WEBPACK_IMPORTED_MODULE_9__/* .useRequiredContext */ .a)(PollContext);
    return context;
};
const PollContextProvider = (param)=>{
    let { poll , urlId , admin , children  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("app");
    const { participants  } = (0,_participants_provider__WEBPACK_IMPORTED_MODULE_8__/* .useParticipants */ .B)();
    const [isDeleted, setDeleted] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const { user  } = (0,_user_provider__WEBPACK_IMPORTED_MODULE_10__/* .useUser */ .aF)();
    const [targetTimeZone, setTargetTimeZone] = react__WEBPACK_IMPORTED_MODULE_3__.useState(_utils_date_time_utils__WEBPACK_IMPORTED_MODULE_5__/* .getBrowserTimeZone */ .ei);
    const getScore = react__WEBPACK_IMPORTED_MODULE_3__.useCallback((optionId)=>{
        return (participants !== null && participants !== void 0 ? participants : []).reduce((acc, curr)=>{
            curr.votes.forEach((vote)=>{
                if (vote.optionId !== optionId) {
                    return;
                }
                if (vote.type === "yes") {
                    acc.yes += 1;
                }
                if (vote.type === "ifNeedBe") {
                    acc.ifNeedBe += 1;
                }
            });
            return acc;
        }, {
            yes: 0,
            ifNeedBe: 0
        });
    }, [
        participants
    ]);
    const { timeFormat  } = (0,_utils_dayjs__WEBPACK_IMPORTED_MODULE_6__/* .useDayjs */ .a)();
    const contextValue = react__WEBPACK_IMPORTED_MODULE_3__.useMemo(()=>{
        const highScore = poll.options.reduce((acc, curr)=>{
            const score = getScore(curr.id).yes;
            return score > acc ? score : acc;
        }, 1);
        const parsedOptions = (0,_utils_date_time_utils__WEBPACK_IMPORTED_MODULE_5__/* .decodeOptions */ .YX)(poll.options, poll.timeZone, targetTimeZone, timeFormat);
        const getParticipantById = (participantId)=>{
            // TODO (Luke Vella) [2022-04-16]: Build an index instead
            const participant = participants === null || participants === void 0 ? void 0 : participants.find((param)=>{
                let { id  } = param;
                return id === participantId;
            });
            return participant;
        };
        const userAlreadyVoted = user && participants ? participants.some((participant)=>participant.userId === user.id) : false;
        const optionIds = parsedOptions.options.map((param)=>{
            let { optionId  } = param;
            return optionId;
        });
        const participantById = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.keyBy)(participants, (participant)=>participant.id);
        const participantsByOptionId = {};
        poll.options.forEach((option)=>{
            participantsByOptionId[option.id] = (participants !== null && participants !== void 0 ? participants : []).filter((participant)=>participant.votes.some((param)=>{
                    let { type , optionId  } = param;
                    return optionId === option.id && type === "yes";
                }));
        });
        const { participantUrlId  } = poll;
        const participantUrl = "".concat(window.location.origin, "/p/").concat(participantUrlId);
        return {
            optionIds,
            userAlreadyVoted,
            poll,
            urlId,
            admin,
            participantUrl,
            getParticipantById: (participantId)=>{
                return participantById[participantId];
            },
            highScore,
            getParticipantsWhoVotedForOption: (optionId)=>participantsByOptionId[optionId],
            getVote: (participantId, optionId)=>{
                var _getParticipantById;
                const vote = (_getParticipantById = getParticipantById(participantId)) === null || _getParticipantById === void 0 ? void 0 : _getParticipantById.votes.find((vote)=>vote.optionId === optionId);
                return vote === null || vote === void 0 ? void 0 : vote.type;
            },
            getScore,
            ...parsedOptions,
            targetTimeZone,
            setTargetTimeZone,
            isDeleted,
            setDeleted
        };
    }, [
        admin,
        getScore,
        isDeleted,
        participants,
        poll,
        targetTimeZone,
        timeFormat,
        urlId,
        user
    ]);
    if (isDeleted) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_error_page__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            icon: _components_icons_trash_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            title: t("deletedPoll"),
            description: t("deletedPollInfo")
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PollContext.Provider, {
        value: contextValue,
        children: children
    });
};


/***/ }),

/***/ 9868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1190);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5489);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _poll_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(384);





const ControlledScrollArea = (param)=>{
    let { className , children  } = param;
    const { availableSpace , scrollPosition  } = (0,_poll_context__WEBPACK_IMPORTED_MODULE_2__/* .usePollContext */ .G)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("min-w-0 overflow-hidden", className),
        style: {
            width: availableSpace,
            maxWidth: availableSpace
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .AnimatePresence */ .M, {
            initial: false,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.div */ .E.div, {
                className: "flex h-full",
                transition: {
                    type: "spring",
                    mass: 0.4
                },
                initial: {
                    x: 0
                },
                animate: {
                    x: scrollPosition * -1
                },
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ControlledScrollArea);


/***/ }),

/***/ 6742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6010);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(692);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7536);
/* harmony import */ var _components_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6995);
/* harmony import */ var _components_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7104);
/* harmony import */ var _utils_form_validation__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6001);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5295);
/* harmony import */ var _name_input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(236);
/* harmony import */ var _poll_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3035);
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3874);
/* harmony import */ var _vote_selector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7424);
/* harmony import */ var _controlled_scroll_area__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9868);
/* harmony import */ var _poll_context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(384);















const ParticipantRowForm = (param, ref)=>{
    let { defaultValues , onSubmit , className , onCancel  } = param;
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("app");
    const { columnWidth , scrollPosition , sidebarWidth , numberOfColumns , goToNextPage , goToPreviousPage , maxScrollPosition , setScrollPosition  } = (0,_poll_context__WEBPACK_IMPORTED_MODULE_11__/* .usePollContext */ .G)();
    const { options , optionIds  } = (0,_poll_context__WEBPACK_IMPORTED_MODULE_7__/* .usePoll */ .XW)();
    const { handleSubmit , control , formState: { errors , submitCount  } , reset  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)({
        defaultValues: {
            name: "",
            votes: [],
            ...defaultValues
        }
    });
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        window.addEventListener("keydown", (e)=>{
            if (e.key === "Escape") {
                onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            }
        });
    }, [
        onCancel
    ]);
    const isColumnVisible = (index)=>{
        return scrollPosition + numberOfColumns * columnWidth > columnWidth * index;
    };
    const checkboxRefs = react__WEBPACK_IMPORTED_MODULE_2__.useRef([]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
        id: "participant-row-form",
        ref: ref,
        onSubmit: handleSubmit(async (param)=>{
            let { name , votes  } = param;
            await onSubmit({
                name,
                votes: (0,_mutations__WEBPACK_IMPORTED_MODULE_8__/* .normalizeVotes */ .mu)(optionIds, votes)
            });
            reset();
        }),
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("flex h-14 shrink-0", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center px-2",
                style: {
                    width: sidebarWidth
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
                    name: "name",
                    rules: {
                        validate: _utils_form_validation__WEBPACK_IMPORTED_MODULE_14__/* .requiredString */ .J
                    },
                    render: (param)=>{
                        let { field  } = param;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_name_input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("w-full", {
                                    "input-error": errors.name && submitCount > 0
                                }),
                                placeholder: t("yourName"),
                                ...field,
                                onKeyDown: (e)=>{
                                    if (e.code === "Tab" && scrollPosition > 0) {
                                        e.preventDefault();
                                        setScrollPosition(0);
                                        setTimeout(()=>{
                                            var _checkboxRefs_current_;
                                            (_checkboxRefs_current_ = checkboxRefs.current[0]) === null || _checkboxRefs_current_ === void 0 ? void 0 : _checkboxRefs_current_.focus();
                                        }, 100);
                                    }
                                },
                                onKeyPress: (e)=>{
                                    if (e.code === "Enter") {
                                        var _checkboxRefs_current_;
                                        e.preventDefault();
                                        (_checkboxRefs_current_ = checkboxRefs.current[0]) === null || _checkboxRefs_current_ === void 0 ? void 0 : _checkboxRefs_current_.focus();
                                    }
                                }
                            })
                        });
                    },
                    control: control
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .Controller */ .Qr, {
                control: control,
                name: "votes",
                render: (param)=>{
                    let { field  } = param;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_controlled_scroll_area__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: options.map((param, index)=>{
                            let { optionId  } = param;
                            const value = field.value[index];
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex shrink-0 items-center justify-center px-2",
                                style: {
                                    width: columnWidth
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vote_selector__WEBPACK_IMPORTED_MODULE_9__/* .VoteSelector */ .B, {
                                    value: value === null || value === void 0 ? void 0 : value.type,
                                    onKeyDown: (e)=>{
                                        if (e.code === "Tab" && index < options.length - 1 && !isColumnVisible(index + 1)) {
                                            e.preventDefault();
                                            goToNextPage();
                                            setTimeout(()=>{
                                                var _checkboxRefs_current_;
                                                (_checkboxRefs_current_ = checkboxRefs.current[index + 1]) === null || _checkboxRefs_current_ === void 0 ? void 0 : _checkboxRefs_current_.focus();
                                            }, 100);
                                        }
                                    },
                                    onChange: (vote)=>{
                                        const newValue = [
                                            ...field.value
                                        ];
                                        newValue[index] = {
                                            optionId,
                                            type: vote
                                        };
                                        field.onChange(newValue);
                                    },
                                    ref: (el)=>{
                                        checkboxRefs.current[index] = el;
                                    }
                                })
                            }, optionId);
                        })
                    });
                }
            }),
            maxScrollPosition > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center space-x-2 px-2 transition-all",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                        disabled: scrollPosition === 0,
                        className: "text-xs",
                        rounded: true,
                        onClick: ()=>{
                            goToPreviousPage();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_arrow_left_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "h-4 w-4"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                        disabled: scrollPosition >= maxScrollPosition,
                        className: "text-xs",
                        rounded: true,
                        onClick: ()=>{
                            goToNextPage();
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_arrow_right_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            className: "h-4 w-4"
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(ParticipantRowForm));


/***/ }),

/***/ 6060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ParticipantRowView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_compact_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6683);
/* harmony import */ var _components_icons_pencil_alt_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4145);
/* harmony import */ var _components_icons_trash_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8405);
/* harmony import */ var _components_poll_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3035);
/* harmony import */ var _components_user_provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7348);
/* harmony import */ var _use_delete_participant_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8196);
/* harmony import */ var _user_avatar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4371);
/* harmony import */ var _vote_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8114);
/* harmony import */ var _controlled_scroll_area__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9868);
/* harmony import */ var _participant_row_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6742);
/* harmony import */ var _poll_context__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(384);














const ParticipantRowView = (param)=>{
    let { name , editable , votes , onEdit , onDelete , sidebarWidth , columnWidth , isYou , color , participantId  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-testid": "participant-row",
        "data-participantid": participantId,
        className: "group flex h-14 items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex shrink-0 items-center px-4",
                style: {
                    width: sidebarWidth
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_user_avatar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: "mr-2",
                        name: name,
                        showName: true,
                        isYou: isYou,
                        color: color
                    }),
                    editable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "hidden shrink-0 items-center space-x-2 overflow-hidden group-hover:flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_compact_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                icon: _components_icons_pencil_alt_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                onClick: onEdit
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_compact_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                icon: _components_icons_trash_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                onClick: onDelete
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_controlled_scroll_area__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: votes.map((vote, i)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative flex shrink-0 items-center justify-center px-2 transition-colors",
                        style: {
                            width: columnWidth
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("flex h-10 w-full items-center justify-center rounded-md", {
                                "bg-green-50": vote === "yes",
                                "bg-amber-50": vote === "ifNeedBe",
                                "bg-slate-50": vote === "no"
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vote_icon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                type: vote
                            })
                        })
                    }, i);
                })
            })
        ]
    });
};
const ParticipantRow = (param)=>{
    let { participant , editMode , onSubmit , onChangeEditMode  } = param;
    const { columnWidth , sidebarWidth  } = (0,_poll_context__WEBPACK_IMPORTED_MODULE_12__/* .usePollContext */ .G)();
    const confirmDeleteParticipant = (0,_use_delete_participant_modal__WEBPACK_IMPORTED_MODULE_7__/* .useDeleteParticipantModal */ .j)();
    const session = (0,_components_user_provider__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .aF)();
    const { poll , getVote , options , admin  } = (0,_components_poll_context__WEBPACK_IMPORTED_MODULE_5__/* .usePoll */ .XW)();
    const isYou = session.user && session.ownsObject(participant) ? true : false;
    const isUnclaimed = !participant.userId;
    const canEdit = !poll.closed && (admin || isYou || isUnclaimed);
    if (editMode) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_participant_row_form__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            defaultValues: {
                name: participant.name,
                votes: options.map((param)=>{
                    let { optionId  } = param;
                    const type = getVote(participant.id, optionId);
                    return type ? {
                        optionId,
                        type
                    } : undefined;
                })
            },
            onSubmit: async (param)=>{
                let { name , votes  } = param;
                await (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
                    name,
                    votes
                }));
                onChangeEditMode === null || onChangeEditMode === void 0 ? void 0 : onChangeEditMode(false);
            },
            onCancel: ()=>{
                return onChangeEditMode === null || onChangeEditMode === void 0 ? void 0 : onChangeEditMode(false);
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParticipantRowView, {
        sidebarWidth: sidebarWidth,
        columnWidth: columnWidth,
        name: participant.name,
        votes: options.map((param)=>{
            let { optionId  } = param;
            return getVote(participant.id, optionId);
        }),
        participantId: participant.id,
        editable: canEdit,
        isYou: isYou,
        onEdit: ()=>{
            onChangeEditMode === null || onChangeEditMode === void 0 ? void 0 : onChangeEditMode(true);
        },
        onDelete: ()=>{
            confirmDeleteParticipant(participant.id);
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParticipantRow);


/***/ }),

/***/ 384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ PollContext; },
/* harmony export */   "G": function() { return /* binding */ usePollContext; }
/* harmony export */ });
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(308);
/* harmony import */ var lodash_noop__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_noop__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const PollContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    activeOptionId: null,
    setActiveOptionId: (lodash_noop__WEBPACK_IMPORTED_MODULE_0___default()),
    scrollPosition: 0,
    maxScrollPosition: 100,
    setScrollPosition: (lodash_noop__WEBPACK_IMPORTED_MODULE_0___default()),
    columnWidth: 100,
    sidebarWidth: 200,
    numberOfColumns: 0,
    availableSpace: "auto",
    goToNextPage: (lodash_noop__WEBPACK_IMPORTED_MODULE_0___default()),
    goToPreviousPage: (lodash_noop__WEBPACK_IMPORTED_MODULE_0___default()),
    actionColumnWidth: 0
});
const usePollContext = ()=>react__WEBPACK_IMPORTED_MODULE_1__.useContext(PollContext);


/***/ }),

/***/ 3874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LB": function() { return /* binding */ useUpdatePollMutation; },
/* harmony export */   "aL": function() { return /* binding */ useAddParticipantMutation; },
/* harmony export */   "bf": function() { return /* binding */ useUpdateParticipantMutation; },
/* harmony export */   "d_": function() { return /* binding */ useDeleteParticipantMutation; },
/* harmony export */   "mu": function() { return /* binding */ normalizeVotes; }
/* harmony export */ });
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9893);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3757);


const normalizeVotes = (optionIds, votes)=>{
    var _votes_i_type;
    return optionIds.map((optionId, i)=>{
        var _votes_i;
        return {
            optionId,
            type: (_votes_i_type = (_votes_i = votes[i]) === null || _votes_i === void 0 ? void 0 : _votes_i.type) !== null && _votes_i_type !== void 0 ? _votes_i_type : "no"
        };
    });
};
const useAddParticipantMutation = ()=>{
    const queryClient = _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpc.useContext */ .S.useContext();
    return _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpc.useMutation */ .S.useMutation([
        "polls.participants.add"
    ], {
        onSuccess: (participant)=>{
            posthog_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].capture */ .ZP.capture("add participant", {
                name: participant.name
            });
            queryClient.setQueryData([
                "polls.participants.list",
                {
                    pollId: participant.pollId
                }
            ], function() {
                let existingParticipants = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                return [
                    ...existingParticipants,
                    participant
                ];
            });
            queryClient.invalidateQueries([
                "polls.participants.list",
                {
                    pollId: participant.pollId
                }
            ]);
        }
    });
};
const useUpdateParticipantMutation = ()=>{
    const queryClient = _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpc.useContext */ .S.useContext();
    return _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpc.useMutation */ .S.useMutation("polls.participants.update", {
        onSuccess: (participant)=>{
            posthog_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].capture */ .ZP.capture("update participant", {
                name: participant.name
            });
            queryClient.setQueryData([
                "polls.participants.list",
                {
                    pollId: participant.pollId
                }
            ], function() {
                let existingParticipants = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                const newParticipants = [
                    ...existingParticipants
                ];
                const index = newParticipants.findIndex((param)=>{
                    let { id  } = param;
                    return id === participant.id;
                });
                if (index !== -1) {
                    newParticipants[index] = participant;
                }
                return newParticipants;
            });
        }
    });
};
const useDeleteParticipantMutation = ()=>{
    const queryClient = _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpc.useContext */ .S.useContext();
    return _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpc.useMutation */ .S.useMutation("polls.participants.delete", {
        onMutate: (param)=>{
            let { participantId , pollId  } = param;
            queryClient.setQueryData([
                "polls.participants.list",
                {
                    pollId: pollId
                }
            ], function() {
                let existingParticipants = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                return existingParticipants.filter((param)=>{
                    let { id  } = param;
                    return id !== participantId;
                });
            });
        },
        onSuccess: (_, param)=>{
            let { participantId  } = param;
            posthog_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].capture */ .ZP.capture("remove participant", {
                participantId
            });
        }
    });
};
const useUpdatePollMutation = ()=>{
    const queryClient = _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpcNext.useContext */ .G.useContext();
    return _utils_trpc__WEBPACK_IMPORTED_MODULE_1__/* .trpc.useMutation */ .S.useMutation([
        "polls.update"
    ], {
        onSuccess: (data)=>{
            queryClient.poll.invalidate();
            posthog_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].capture */ .ZP.capture("updated poll", {
                id: data.id
            });
        }
    });
};


/***/ }),

/***/ 9398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ ScoreSummary; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(1190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 168 modules
var motion = __webpack_require__(5489);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/usePrevious.js
var usePrevious = __webpack_require__(7176);
;// CONCATENATED MODULE: ./src/components/icons/user-solid.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUserSolid = function SvgUserSolid(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 9a3 3 0 0 0-3 3v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3H6Z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ var user_solid = (SvgUserSolid);
;// CONCATENATED MODULE: ./src/components/poll/score-summary.tsx





const ScoreSummary = /*#__PURE__*/ react.memo(function PopularityScore(param) {
    let { yesScore: score  } = param;
    const prevScore = (0,usePrevious/* default */.Z)(score);
    const direction = prevScore !== undefined ? score - prevScore : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "popularity-score",
        className: "flex items-center gap-1 text-sm font-bold tabular-nums",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(user_solid, {
                className: "inline-block h-4 text-slate-300 transition-opacity"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                initial: false,
                exitBeforeEnter: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                    transition: {
                        duration: 0.1
                    },
                    initial: {
                        opacity: 0,
                        y: 10 * direction
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: 10 * direction
                    },
                    className: "relative",
                    children: score
                }, score)
            })
        ]
    });
});


/***/ }),

/***/ 8196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useDeleteParticipantModal; }
/* harmony export */ });
/* harmony import */ var _modal_modal_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(366);
/* harmony import */ var _poll_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3035);
/* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3874);



const useDeleteParticipantModal = ()=>{
    const { render  } = (0,_modal_modal_provider__WEBPACK_IMPORTED_MODULE_0__/* .useModalContext */ .v)();
    const deleteParticipant = (0,_mutations__WEBPACK_IMPORTED_MODULE_2__/* .useDeleteParticipantMutation */ .d_)();
    const { poll  } = (0,_poll_context__WEBPACK_IMPORTED_MODULE_1__/* .usePoll */ .XW)();
    return (participantId)=>{
        return render({
            title: "Delete participant?",
            description: "Are you sure you want to remove this participant from the poll?",
            okButtonProps: {
                type: "danger"
            },
            okText: "Delete",
            onOk: ()=>{
                deleteParticipant.mutate({
                    pollId: poll.id,
                    participantId
                });
            },
            cancelText: "Cancel"
        });
    };
};


/***/ }),

/***/ 4371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ UserAvatarProvider; },
  "Z": function() { return /* binding */ user_avatar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/utils/string-to-value.ts
const stringToValue = (seed)=>{
    let num = 0;
    for(let i = 0; i < seed.length; i++){
        num += seed.charCodeAt(i);
    }
    return num;
};

// EXTERNAL MODULE: ./src/components/badge.tsx
var badge = __webpack_require__(5823);
;// CONCATENATED MODULE: ./src/components/poll/user-avatar.tsx






const UserAvatarContext = /*#__PURE__*/ react.createContext(null);
const colors = [
    "bg-fuchsia-300",
    "bg-purple-400",
    "bg-primary-400",
    "bg-blue-400",
    "bg-sky-400",
    "bg-cyan-400",
    "bg-sky-400",
    "bg-blue-400",
    "bg-primary-400",
    "bg-purple-400",
    "bg-fuchsia-400",
    "bg-pink-400"
];
const defaultColor = "bg-slate-400";
const UserAvatarProvider = (param)=>{
    let { seed , children , names  } = param;
    const seedValue = react.useMemo(()=>stringToValue(seed), [
        seed
    ]);
    const colorByName = react.useMemo(()=>{
        const res = {
            "": defaultColor
        };
        for(let i = 0; i < names.length; i++){
            const name = names[i].trim().toLowerCase();
            const color = colors[(seedValue + i) % colors.length];
            res[name] = color;
        }
        return res;
    }, [
        names,
        seedValue
    ]);
    const getColor = react.useCallback((name)=>{
        const cachedColor = colorByName[name.toLowerCase()];
        if (cachedColor) {
            return cachedColor;
        }
        return defaultColor;
    }, [
        colorByName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatarContext.Provider, {
        value: getColor,
        children: children
    });
};
const UserAvatarInner = (param)=>{
    let { name , className , color: colorOverride , size ="default"  } = param;
    var _trimmedName_;
    const trimmedName = name.trim();
    const getColor = react.useContext(UserAvatarContext);
    if (!getColor) {
        throw new Error("Forgot to wrap UserAvatarProvider");
    }
    const color = colorOverride !== null && colorOverride !== void 0 ? colorOverride : getColor(trimmedName);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)("inline-block h-5 w-5 shrink-0 rounded-full text-center text-white", color, {
            "h-5 w-5 text-xs leading-5": size === "default",
            "h-10 w-10 leading-10": size === "large"
        }, className),
        title: name,
        children: (_trimmedName_ = trimmedName[0]) === null || _trimmedName_ === void 0 ? void 0 : _trimmedName_.toUpperCase()
    });
};
const UserAvatar = (param)=>{
    let { showName , isYou , className , ...forwardedProps } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("app");
    if (!showName) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatarInner, {
            className: className,
            ...forwardedProps
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("inline-flex items-center space-x-2 overflow-hidden", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatarInner, {
                ...forwardedProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "min-w-0 truncate",
                title: forwardedProps.name,
                children: forwardedProps.name
            }),
            isYou ? /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                children: t("you")
            }) : null
        ]
    });
};
/* harmony default export */ var user_avatar = (UserAvatar);


/***/ }),

/***/ 8114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ vote_icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/icons/check-circle.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "check-circle_svg__h-5 check-circle_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm3.707-9.293a1 1 0 0 0-1.414-1.414L9 10.586 7.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ var check_circle = (SvgCheckCircle);
;// CONCATENATED MODULE: ./src/components/icons/if-need-be.svg
var if_need_be_path;

function if_need_be_extends() { if_need_be_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return if_need_be_extends.apply(this, arguments); }



var SvgIfNeedBe = function SvgIfNeedBe(props) {
  return /*#__PURE__*/react.createElement("svg", if_need_be_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), if_need_be_path || (if_need_be_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.106-7.553c-.31-.62-.586-1.014-.813-1.24C12.116 9.03 12.02 9.004 12 9c-.02.004-.116.03-.293.207-.226.226-.503.62-.812 1.24-.357.714-.747 1.32-1.188 1.76C9.265 12.65 8.692 13 8 13c-.692 0-1.265-.35-1.707-.793-.44-.44-.83-1.046-1.187-1.76a1 1 0 1 1 1.789-.894c.31.62.586 1.013.812 1.24.177.177.273.204.293.207.02-.004.116-.03.293-.207.226-.226.503-.62.813-1.24.357-.714.747-1.32 1.187-1.76C10.735 7.35 11.308 7 12 7c.692 0 1.265.35 1.707.793.44.44.83 1.046 1.188 1.76a1 1 0 1 1-1.79.894ZM11.996 9H12h-.002Zm.005 0h.003-.003Zm-3.997 2h-.003.003ZM8 11h-.003H8Z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ var if_need_be = (SvgIfNeedBe);
;// CONCATENATED MODULE: ./src/components/icons/question-mark.svg
var question_mark_path;

function question_mark_extends() { question_mark_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return question_mark_extends.apply(this, arguments); }



var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/react.createElement("svg", question_mark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), question_mark_path || (question_mark_path = /*#__PURE__*/react.createElement("path", {
    d: "M4 5.313c0-.502.163-1.01.488-1.522.325-.518.8-.946 1.424-1.284C6.536 2.17 7.264 2 8.096 2c.773 0 1.456.143 2.048.428.592.28 1.048.663 1.368 1.15.325.485.488 1.014.488 1.584 0 .45-.093.843-.28 1.181-.181.339-.4.632-.656.88-.25.243-.704.655-1.36 1.237a5.696 5.696 0 0 0-.44.436 1.676 1.676 0 0 0-.368.65c-.027.1-.07.28-.128.539-.101.55-.419.824-.952.824a.992.992 0 0 1-.704-.27c-.187-.18-.28-.446-.28-.8 0-.444.07-.827.208-1.15.139-.327.323-.612.552-.855.23-.249.539-.542.928-.88.341-.296.587-.518.736-.666a2.2 2.2 0 0 0 .384-.507c.107-.185.16-.386.16-.603 0-.422-.16-.78-.48-1.07-.315-.29-.723-.436-1.224-.436-.587 0-1.019.148-1.296.444-.277.29-.512.722-.704 1.292-.181.597-.525.896-1.032.896a1.04 1.04 0 0 1-.76-.31C4.101 5.785 4 5.557 4 5.315ZM7.904 14a1.29 1.29 0 0 1-.856-.31c-.24-.21-.36-.504-.36-.879 0-.333.117-.613.352-.84.235-.227.523-.34.864-.34.336 0 .619.113.848.34.23.227.344.507.344.84 0 .37-.12.66-.36.872-.24.211-.517.317-.832.317Z"
  })));
};

/* harmony default export */ var question_mark = (SvgQuestionMark);
;// CONCATENATED MODULE: ./src/components/icons/x-circle.svg
var x_circle_path;

function x_circle_extends() { x_circle_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return x_circle_extends.apply(this, arguments); }



var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/react.createElement("svg", x_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "x-circle_svg__h-5 x-circle_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), x_circle_path || (x_circle_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM8.707 7.293a1 1 0 0 0-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 1 0 1.414 1.414L10 11.414l1.293 1.293a1 1 0 0 0 1.414-1.414L11.414 10l1.293-1.293a1 1 0 0 0-1.414-1.414L10 8.586 8.707 7.293z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ var x_circle = (SvgXCircle);
;// CONCATENATED MODULE: ./src/components/poll/vote-icon.tsx







const VoteIcon = (param)=>{
    let { type , className , size ="md"  } = param;
    switch(type){
        case "yes":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(check_circle, {
                className: (0,clsx_m/* default */.Z)("text-green-400", className, {
                    "h-5": size === "md",
                    "h-3": size === "sm"
                })
            });
        case "ifNeedBe":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(if_need_be, {
                className: (0,clsx_m/* default */.Z)("text-amber-300", className, {
                    "h-5": size === "md",
                    "h-3": size === "sm"
                })
            });
        case "no":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(x_circle, {
                className: (0,clsx_m/* default */.Z)("text-slate-300", className, {
                    "h-5": size === "md",
                    "h-3": size === "sm"
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(question_mark, {
                className: (0,clsx_m/* default */.Z)("text-slate-300", className, {
                    "h-5": size === "md",
                    "h-3": size === "sm"
                })
            });
    }
};
/* harmony default export */ var vote_icon = (VoteIcon);


/***/ }),

/***/ 7424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ VoteSelector; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1190);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5489);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _vote_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8114);





const orderedVoteTypes = [
    "yes",
    "ifNeedBe",
    "no"
];
const getNext = (value)=>{
    return orderedVoteTypes[(orderedVoteTypes.indexOf(value) + 1) % orderedVoteTypes.length];
};
const VoteSelector = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function VoteSelector(param, ref) {
    let { value , onChange , onFocus , onBlur , onKeyDown , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        "data-testid": "vote-selector",
        type: "button",
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("group relative inline-flex h-9 w-full items-center justify-center overflow-hidden rounded-md border bg-white transition-all hover:ring-4 focus-visible:border-0 focus-visible:ring-2 focus-visible:ring-primary-500", {
            "border-green-200 bg-green-50 hover:ring-green-100/50 active:bg-green-100/50": value === "yes",
            "border-amber-200 bg-amber-50 hover:ring-amber-100/50 active:bg-amber-100/50": value === "ifNeedBe",
            "border-gray-200 bg-gray-50 hover:ring-gray-100/50 active:bg-gray-100/50": value === "no",
            "border-gray-200 hover:ring-gray-100/50 active:bg-gray-100/50": value === undefined
        }, className),
        onClick: ()=>{
            onChange === null || onChange === void 0 ? void 0 : onChange(value ? getNext(value) : orderedVoteTypes[0]);
        },
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .AnimatePresence */ .M, {
            initial: false,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.span */ .E.span, {
                className: "absolute flex items-center justify-center",
                transition: {
                    duration: 0.2
                },
                initial: {
                    opacity: 0,
                    scale: 1.5,
                    y: -45
                },
                animate: {
                    opacity: 1,
                    scale: 1,
                    y: 0
                },
                exit: {
                    opacity: 0,
                    scale: 0.5,
                    y: 45
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vote_icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    type: value
                })
            }, value)
        })
    });
});


/***/ }),

/***/ 5422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ expectTimeOption; },
/* harmony export */   "D9": function() { return /* binding */ encodeDateOption; },
/* harmony export */   "YX": function() { return /* binding */ decodeOptions; },
/* harmony export */   "ZP": function() { return /* binding */ getDateProps; },
/* harmony export */   "eU": function() { return /* binding */ removeAllOptionsForDay; },
/* harmony export */   "ei": function() { return /* binding */ getBrowserTimeZone; },
/* harmony export */   "g9": function() { return /* binding */ getDuration; }
/* harmony export */ });
/* unused harmony export parseValue */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

const getBrowserTimeZone = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone;
const encodeDateOption = (option)=>{
    return option.type === "timeSlot" ? "".concat(option.start, "/").concat(option.end) : option.date;
};
const isTimeSlot = (value)=>value.indexOf("/") !== -1;
const getDuration = (startTime, endTime)=>{
    const hours = Math.floor(endTime.diff(startTime, "hours"));
    const minutes = Math.floor(endTime.diff(startTime, "minute") - hours * 60);
    let res = "";
    if (hours) {
        res += "".concat(hours, "h");
    }
    if (hours && minutes) {
        res += " ";
    }
    if (minutes) {
        res += "".concat(minutes, "m");
    }
    return res;
};
const decodeOptions = (options, timeZone, targetTimeZone, // eslint-disable-next-line @typescript-eslint/no-unused-vars
_timeFormat)=>{
    const pollType = isTimeSlot(options[0].value) ? "timeSlot" : "date";
    if (pollType === "timeSlot") {
        return {
            pollType,
            options: options.map((option)=>parseTimeSlotOption(option, timeZone, targetTimeZone))
        };
    } else {
        return {
            pollType,
            options: options.map((option)=>parseDateOption(option))
        };
    }
};
const parseDateOption = (option)=>{
    const dateString = option.value.indexOf("T") === -1 ? option.value + "T00:00:00" : option.value;
    const date = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateString);
    return {
        type: "date",
        optionId: option.id,
        day: date.format("D"),
        dow: date.format("ddd"),
        month: date.format("MMM"),
        year: date.format("YYYY")
    };
};
const parseTimeSlotOption = (option, timeZone, targetTimeZone)=>{
    const [start, end] = option.value.split("/");
    const startDate = timeZone && targetTimeZone ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(start).tz(timeZone, true).tz(targetTimeZone) : dayjs__WEBPACK_IMPORTED_MODULE_0___default()(start);
    const endDate = timeZone && targetTimeZone ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(end).tz(timeZone, true).tz(targetTimeZone) : dayjs__WEBPACK_IMPORTED_MODULE_0___default()(end);
    return {
        type: "timeSlot",
        optionId: option.id,
        startTime: startDate.format("LT"),
        endTime: endDate.format("LT"),
        day: startDate.format("D"),
        dow: startDate.format("ddd"),
        month: startDate.format("MMM"),
        duration: getDuration(startDate, endDate),
        year: startDate.format("YYYY")
    };
};
const removeAllOptionsForDay = (options, date)=>{
    return options.filter((option)=>{
        return !dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isSame(option.type === "date" ? option.date : option.start, "day");
    });
};
const getDateProps = (date)=>{
    const d = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date);
    return {
        day: d.format("D"),
        dow: d.format("ddd"),
        month: d.format("MMM")
    };
};
const expectTimeOption = (d)=>{
    if (d.type === "date") {
        throw new Error("Expected timeSlot but got date instead");
    }
    return d;
};
const parseValue = (value)=>{
    if (isTimeSlot(value)) {
        const [start, end] = value.split("/");
        return {
            type: "timeSlot",
            start,
            end
        };
    } else {
        return {
            type: "date",
            date: value
        };
    }
};


/***/ })

}]);